import React from "react";
import useOkendo from "hooks/useOkendo";
import RichText from "components/rich-text";

const OkendoMediaGrid = ({ data }) => {
	const widgetContainer = useOkendo();
	const groupId = data.groupId;

	return (
		<div className="">
			{data?.title && <h2 className="mb-4">{data.title}</h2>}
			<RichText data={{ content: data.content }} />
			<div
				className="mt-10"
				ref={widgetContainer}
				data-oke-media-grid
				{...(groupId && { "data-oke-reviews-group-id": groupId })}
			/>
		</div>
	);
};

export default OkendoMediaGrid;